import { Link } from "react-router-dom"
import { ArrowLeft, Menu, Sparkles } from "lucide-react"

export function AskDynamoHeader() {
  return (
    <header className="flex items-center justify-between gap-3">
      <Link
        to="/dashboard"
        className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[var(--color-text-primary)] transition hover:bg-black/5"
        aria-label="Back to dashboard"
      >
        <ArrowLeft size={20} aria-hidden />
      </Link>

      <h1 className="flex min-w-0 flex-1 items-center justify-center gap-2 text-base font-semibold text-[var(--color-ask-dynamo-muted)]">
        <Sparkles size={18} className="shrink-0 text-[var(--color-ask-dynamo)]" aria-hidden />
        Ask Dynamo
      </h1>

      <button
        type="button"
        className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[var(--color-text-secondary)] opacity-50"
        aria-label="Menu"
        disabled
      >
        <Menu size={20} aria-hidden />
      </button>
    </header>
  )
}
